import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  ApiCardsDashboard,
  ApiChartsDashboard,
  ApiStatsInfoDashboard,
  BalanceInfo,
  CostsEarningsInfo,
  PaidEarnedInfo,
  PendingLifetimeInfo,
} from 'types/api/api-dashboard';

interface DashboardState {
  statsInfo: ApiStatsInfoDashboard | null;
  cardsInfo: ApiCardsDashboard;
  chartsInfo: ApiChartsDashboard;
  isLoading: boolean;
}

export const initialState: DashboardState = {
  statsInfo: null,

  cardsInfo: {
    balanceInfo: { balance: 0, deposit: 0 },
    costsEarningsInfo: { costs: 0, earnings: 0, profit: 0 },
    pendingLifetimeInfo: {
      pendingPoolBalanceCoins: 0,
      pendingPoolBalanceAmount: 0,
      lifetimeEarningsCoins: 0,
      lifetimeEarningsAmount: 0,
    },
    paidEarnedInfo: { paidAmount: 0, earnedAmount: 0 },
  },

  chartsInfo: {
    id: '',
    bitcoinEarnings: [],
    electricityConsumption: [],
  },

  isLoading: false,
};

const slice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setStatsInfo: (state, action: PayloadAction<ApiStatsInfoDashboard>) => {
      state.statsInfo = {
        ...action.payload,
        hashpowerMarketPlace: {
          name: 'Hashpower Marketplace',
          id: '',
          count: 0,
          // errors: 0,
          percent: 0,
        },
      };
    },

    setDashboardCardsInfo: (state, action: PayloadAction<ApiCardsDashboard>) => {
      state.cardsInfo = action.payload;
    },

    setChartsInfo: (state, action: PayloadAction<ApiChartsDashboard>) => {
      state.chartsInfo = action.payload;
    },
    setDashboardCardsInfoLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export default slice.reducer;
// selectors
export const dashboardStatsInfoSelector = (state: { dashboard: DashboardState }): ApiStatsInfoDashboard | null =>
  state.dashboard.statsInfo;
export const dashboardBalanceCardsSelector = (state: { dashboard: DashboardState }): BalanceInfo =>
  state.dashboard.cardsInfo?.balanceInfo;
export const dashboardCostsEarningsInfoSelector = (state: { dashboard: DashboardState }): CostsEarningsInfo =>
  state.dashboard.cardsInfo?.costsEarningsInfo;
export const dashboardBTCBalanceCardsSelector = (state: { dashboard: DashboardState }): PendingLifetimeInfo =>
  state.dashboard.cardsInfo?.pendingLifetimeInfo;
export const dashboardPaidEarnedInfoSelector = (state: { dashboard: DashboardState }): PaidEarnedInfo =>
  state.dashboard.cardsInfo?.paidEarnedInfo;
export const dashboardCardsInfoLoadingSelector = (state: { dashboard: DashboardState }): boolean =>
  state.dashboard.isLoading;
export const dashboardChartsInfoSelector = (state: { dashboard: DashboardState }): ApiChartsDashboard =>
  state.dashboard.chartsInfo;

// actions
export const { setStatsInfo, setDashboardCardsInfo, setChartsInfo, setDashboardCardsInfoLoading } = slice.actions;
